import { en } from './catalog.en';
import { es } from './catalog.es';

export const catalogs = { en, es } as const;

export type Locale = keyof typeof catalogs;

export const SUPPORTED_LOCALES: readonly Locale[] = ['en', 'es'] as const;

export const DEFAULT_LOCALE: Locale = 'en';